<template>
    <div class="left_panel add_new_store_page">
        <div class="row checkout_wizard">
            <div class="col-lg-3">
                <h2 class="font_size_20 font-weight-bold mb-0 text_black">
                    Add New Store
                </h2>
            </div>
            <div class="col-lg-6">
                <div
                    class="wizard d-flex justify-content-center align-items-center"
                >
                    <div
                        class="field d-flex justify-content-center align-items-center"
                    >
                        <div class="circle mr_10">1</div>
                        <h5 class="mb-0">Store Details</h5>
                    </div>
                    <div class="devider"></div>
                    <div
                        class="field in_active d-flex justify-content-center align-items-center"
                    >
                        <div class="circle mr_10">2</div>
                        <h5 class="mb-0">Add Products</h5>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 accordian_with_form">
                <div class="accordion mt_50" id="accordionExample">
                    <div class="card">
                        <div class="card-header p-0" id="headingOne">
                            <h2
                                class="mb-0 accordian_heading text-left d-flex"
                                style="
                                    color: #0079c1 !important;
                                    font-weight: normal !important;
                                    font-family: 'proximaNova-regular' !important;
                                "
                            >
                                Store Details
                            </h2>
                        </div>
                        <div
                            id="collapseOne"
                            class="collapse show"
                            aria-labelledby="headingOne"
                            data-parent="#accordionExample"
                        >
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12 col-lg-6 d-flex">
                                        <div class="form-group w-100 pr_44">
                                            <input
                                                type="text"
                                                id="Email"
                                                required="required"
                                                placeholder="Enter here"
                                                class="form-control bg-transparent"
                                            />
                                            <label>Store Name</label>
                                            <span class="highlight"></span>
                                        </div>
                                    </div>
                                    <div
                                        class="col-md-12 col-lg-6 d-flex align-items-end justify-content-between num_participent"
                                    >
                                        <div class="form-group w_80">
                                            <label>Store Type</label>
                                            <span class="highlight"></span>
                                            <select
                                                class="form-control bg-transparent"
                                            >
                                                <option>La Crosse</option>
                                            </select>
                                        </div>
                                        <div
                                            class="edit_view text-center align-self-end mb-1"
                                        >
                                            <a
                                                class="font_size_16 text_primary_blue"
                                                href="#"
                                                >View / Edit</a
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt_44">
                                    <div class="col-md-12 col-lg-6">
                                        <div class="form-group pr_44">
                                            <input
                                                type="text"
                                                id="Email"
                                                required="required"
                                                placeholder="St Regis"
                                                class="form-control bg-transparent"
                                            />
                                            <label>Store Code</label>
                                            <span class="highlight"></span>
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-6 d-flex">
                                        <div class="form-group w-50 pr_44">
                                            <label>State</label>
                                            <span class="highlight"></span>
                                            <select
                                                class="form-control bg-transparent"
                                            >
                                                <option>California</option>
                                            </select>
                                        </div>
                                        <div class="form-group w-50">
                                            <label>City</label>
                                            <span class="highlight"></span>
                                            <select
                                                class="form-control bg-transparent"
                                            >
                                                <option>Los Angeles</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt_44">
                                    <div class="col-md-12 col-lg-6">
                                        <div class="form-group pr_44">
                                            <input
                                                type="text"
                                                id="Email"
                                                required="required"
                                                placeholder="Enter here"
                                                class="form-control bg-transparent"
                                            />
                                            <label
                                                >School or Club / Group
                                                Name</label
                                            >
                                            <span class="highlight"></span>
                                        </div>
                                    </div>
                                    <div
                                        class="mobile_dflex col-md-12 col-lg-6 d-flex align-items-end justify-content-between num_participent"
                                    >
                                        <div class="form-group w_90">
                                            <input
                                                type="text"
                                                id="Email"
                                                required="required"
                                                placeholder="Enter here"
                                                class="form-control bg-transparent"
                                            />
                                            <label>Number of Participant</label>
                                            <span class="highlight"></span>
                                        </div>
                                        <div class="plus_icon mb_6">
                                            <span
                                                ><img
                                                    src="/maincss/images/plus_icon_BG.svg"
                                            /></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt_44">
                                    <div class="col-md-12 col-lg-6">
                                        <div class="form-group pr_44">
                                            <input
                                                type="text"
                                                id="Email"
                                                required="required"
                                                placeholder="Enter here"
                                                class="form-control bg-transparent"
                                            />
                                            <label
                                                >Select Team Names or Coach /
                                                Teacher</label
                                            >
                                            <span class="highlight"></span>
                                        </div>
                                    </div>
                                    <div
                                        class="mobile_dflex col-md-12 col-lg-6 d-flex align-items-end justify-content-between num_participent"
                                    >
                                        <div class="form-group w_90">
                                            <input
                                                type="text"
                                                id="Email"
                                                required="required"
                                                placeholder="Enter here"
                                                class="form-control bg-transparent"
                                            />
                                            <label>Team Name</label>
                                            <span class="highlight"></span>
                                        </div>
                                        <div class="plus_icon mb_6">
                                            <span
                                                ><img
                                                    src="/maincss/images/plus_icon_BG.svg"
                                            /></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt_44">
                                    <div class="col-md-12 col-lg-6">
                                        <div class="form-group pr_44">
                                            <input
                                                type="text"
                                                id="Email"
                                                required="required"
                                                placeholder="Enter here"
                                                class="form-control bg-transparent"
                                            />
                                            <label>Order Handling Fee</label>
                                            <span class="highlight"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="buttons mt_24 ml-auto text-right">
                    <a
                        href="#"
                        class="btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_60 mr_34"
                        >Cancel</a
                    >
                    <a
                        href="#"
                        class="btn btn_orange bg_primary_orange text_white py_18 px_52"
                        >Save and add Products</a
                    >
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "AddNewStore",
    components: {},
    mounted() {
        document.body.classList.add("bg_primary_light_white");
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });
        /* eslint-enable */
    }
};
</script>
